import React, { useState, useMemo } from 'react';
import BounceRateMonitoring from './BounceRateMonitoring';
import TestEmailSender from './TestEmailSender';
import EmailLogsViewer from './EmailLogsViewer';
import { PageContent, PageSection } from 'common/styles/page';
import { Button, Dropdown, Icon } from 'semantic-ui-react';

const MessagingMonitoring: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedDays, setSelectedDays] = useState(30);
  const [refreshSignal, setRefreshSignal] = useState(0);

  const tabs = ['Bounce Monitoring', 'Email Testing', 'Email Logs'];

  const dayOptions = useMemo(
    () => ([
      { key: 1, text: 'Last 24 hours', value: 1 },
      { key: 7, text: 'Last 7 days', value: 7 },
      { key: 30, text: 'Last 30 days', value: 30 },
      { key: 90, text: 'Last 90 days', value: 90 },
      { key: 365, text: 'Last 1 year', value: 365 },
    ]),
    []
  );

  return (
    <PageContent data-testid="admin-messaging-monitoring-page">
      {/* Header row: tabs on left, days dropdown + refresh on right */}
      <PageSection display="flex" alignItems="center" justifyContent="space-between">
        <div>
          <Button.Group>
            {tabs.map((t, idx) => {
              const tabColors = ['orange', 'teal', 'blue'];
              const color = tabColors[idx] || undefined;
              return (
                <Button
                  key={t}
                  color={color as any}
                  basic={selectedTab !== idx}
                  active={selectedTab === idx}
                  onClick={() => setSelectedTab(idx)}
                >
                  {t}
                </Button>
              );
            })}
          </Button.Group>
        </div>

        {selectedTab === 0 && (
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <Dropdown
              selection
              value={selectedDays}
              onChange={(_, { value }) => setSelectedDays(Number(value))}
              options={dayOptions}
              data-testid="messaging-days-dropdown"
            />
            <Button
              icon
              title="Refresh"
              aria-label="Refresh"
              onClick={() => setRefreshSignal(prev => prev + 1)}
              size="small"
            >
              <Icon name="refresh" />
            </Button>
          </div>
        )}
      </PageSection>

      <PageSection>
        {tabs[selectedTab] === 'Bounce Monitoring' && (
          <PageSection padright>
            <BounceRateMonitoring selectedDays={selectedDays} setSelectedDays={setSelectedDays} />
          </PageSection>
        )}
        {tabs[selectedTab] === 'Email Testing' && (
          <PageSection>
            <TestEmailSender />
          </PageSection>
        )}
        {tabs[selectedTab] === 'Email Logs' && (
          <PageSection padtop>
            <EmailLogsViewer />
          </PageSection>
        )}
      </PageSection>
    </PageContent>
  );
};

export default MessagingMonitoring;
